import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function TraiesteCurriculum() {
  const curriculum = [{
    title: 'Vei învăța cum să practici cele 7 legi spirituale ale succesului.',
    desc: 'Șapte principii care te ajută să trăiești în armonie cu tine și cu viața, și să atragi prosperitate în mod natural, fără forțare și fără stres.'
  }, {
    title: 'Vei descoperi conceptul de conștiință a bogăției.',
    desc: 'Înțelegi cum să obții prosperitate în mod spontan, nu prin efort excesiv, ci prin alinierea dintre ce gândești, ce simți și ce faci în fiecare zi.'
  }, {
    title: 'Vei învăța exerciții practice pentru o sănătate mai bună.',
    desc: 'Nu doar teorie despre stare de bine, ci tehnici concrete pe care le aplici zilnic și care îți susțin corpul, mintea și energia.'
  }, {
    title: 'Vei experimenta recunoștința și iubirea în viața ta de zi cu zi.',
    desc: 'Practici simple care îți schimbă perspectiva asupra a ceea ce ai deja și te ajută să atragi mai mult din ceea ce îți dorești.'
  }, {
    title: 'Vei învăța să trăiești conștient în prezent.',
    desc: 'Nu mai trăiești cu mintea în trecut sau cu anxietatea viitorului. Descoperi cum să fii aici, acum, și cum asta schimbă totul.'
  }, {
    title: 'Vei începe să îți transformi visurile în realitate.',
    desc: 'Nu mai rămân doar gânduri frumoase. Primești un proces clar prin care le aduci în viața ta, pas cu pas, conștient și cu sens.'
  }];
  return <section className="py-20 lg:py-32 bg-brand-cream relative" data-id="element-2015">
      <div className="max-w-4xl mx-auto px-6" data-id="element-2016">
        <SectionHeading title="Ce vei descoperi în acest curs" data-id="element-2017" />

        <div className="space-y-5 mb-16" data-id="element-2018">
          {curriculum.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="flex gap-4 items-start bg-white p-6 md:p-7 rounded-2xl shadow-sm border border-brand-text/5 hover:shadow-warm transition-shadow" data-id="element-2019">
              <div className="flex-shrink-0 mt-1 w-10 h-10 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-2020">
                <CheckCircle2 className="w-6 h-6 text-brand-gold" data-id="element-2021" />
              </div>
              <div data-id="element-2022">
                <h3 className="font-bold text-lg text-brand-text mb-2" data-id="element-2023">
                  {item.title}
                </h3>
                <p className="text-brand-textSec leading-relaxed" data-id="element-2024">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-2025">
          <CTAButton data-id="element-2026" />
        </motion.div>
      </div>
    </section>;
}